import React from 'react';
import {Trans, useTranslation} from 'react-i18next';
import Grid from '@mui/material/Grid';
import Panel from 'components/Panel';
import Button from 'components/Button';
import {SearchObjectType, useSearchApi} from 'features/layout/DialogRoutes/dialogs/search/hooks';
import {filterByObjectType} from 'common/utils';
import {DiplomatObjectType} from 'types/DiplomatObjectType';
import SearchMoveForm from 'components/forms/SearchMoveForm';
import SearchResults from 'components/SearchResults';
import SearchResultsList from 'components/SearchResultsList';
import Box from '@mui/material/Box';

type SearchPartnerFormProps = {
   onClose?: () => void;
};

const SearchPartnerForm = ({onClose}: SearchPartnerFormProps) => {
   const {t} = useTranslation();
   const {results, search, exportResults} = useSearchApi(
      SearchObjectType.Partner,
      t('Partner Export'),
      t('Selected partners successfully exported')
   );

   const externalPartners = React.useMemo(
      () => filterByObjectType(results, DiplomatObjectType.enum.EXTERNAL_PARTNER),
      [results]
   );
   const internalPartners = React.useMemo(
      () => filterByObjectType(results, DiplomatObjectType.enum.INTERNAL_PARTNER),
      [results]
   );

   return (
      <>
         <SearchMoveForm
            searchFieldsLabel={t('Include all partners or find partners with:')}
            searchResult={
               results ? <Trans t={t}>{{itemsCount: results.length}} Partners found.</Trans> : null
            }
            onSubmit={search}
         />
         <SearchResults
            label={t('Double-click to edit a partner.')}
            data={results}
            resultListComponent={
               <>
                  <Grid item xs={6}>
                     <Panel name={t('Public')}>
                        <SearchResultsList data={externalPartners} />
                     </Panel>
                  </Grid>
                  <Grid item xs={6}>
                     <Panel name={t('Trusted')}>
                        <SearchResultsList data={internalPartners} />
                     </Panel>
                  </Grid>
               </>
            }
            onExport={exportResults}
         />
         {onClose && (
            <Box textAlign={'center'}>
               <Button onClick={onClose}>{t('Close')}</Button>
            </Box>
         )}
      </>
   );
};

export default React.memo(SearchPartnerForm);
